import React, { FC, useEffect, useState } from 'react'
import { IInfrastructureProject, IInfrastructureProjectObject, InfrastructureProjectType } from '../../../../types/project.types'
import classes from './styles.module.scss'
import generalClasses from '../styles.module.scss'
import { useTranslation } from 'react-i18next';
import Field from '../../../../components/field/field.component';
import { findOptionByValue, isEmpty, t } from '../../../../helpers/utils';
import ReactSelect from 'react-select';
import Documentation from '../../components/documentation.component';
import SportSections from '../../components/sport-sections.component';
import AdditionalInfo from '../../components/additional-info.component';
import FooterComponent from '../../components/footer.component';
import ImageGrid from '../../components/image-grid.component';
import { useParams } from 'react-router-dom';
import { updateInfrastructureProject } from '../../../../requests/supervisor.request';
import { toast } from 'react-toastify';
import { conditionOptions, options, requirementsOptions } from '../../../../consts/project.const';

interface IProps {
  data: IInfrastructureProjectObject
  loadData: () => void;
}

const keys: Array<keyof IInfrastructureProject> = [
  'constructionYear',
  'factInfo',
  'power',
  'isSchool',
  'factCondition',
  'requirements',
  'nameRu',
  'nameKz',
]

const baseClass = 'education-tab';
const translationKey = 'projects.infrastructure-projects.education';

const EducationTab: FC<IProps> = ({ data, loadData }) => {
  const { tab } = useParams<{ tab: string }>();
  const { i18n: { language } } = useTranslation();
  const [formData, setFormData] = useState<IInfrastructureProjectObject>(data);
  const [errors, setErrors] = useState<Record<string, boolean>>({});
  const { kato } = useParams<{ kato: string }>();
  const [isAddingFund, setIsAddingFund] = useState(false);
  const [newFund, setNewFund] = useState<{ labelRu: string; labelKz: string; value: string }>({ labelRu: '', labelKz: '', value: '' });

  const [isAddingSection, setIsAddingSection] = useState(false);
  const [newSection, setNewSection] = useState<{ label: string; value: string }>({ label: '', value: '' });

  const [isAddingInfo, setIsAddingInfo] = useState(false);
  const [newInfo, setNewInfo] = useState<{ labelRu: string; labelKz: string; valueRu: string; valueKz: string }>({ labelRu: '', labelKz: '', valueRu: '', valueKz: '' });

  const [isAddingText, setIsAddingText] = useState(false);
  const [newText, setNewText] = useState({
    textRu: '',
    textKz: ''
  });



  const handleInputChange = (field: string, value: string | number) => {
    if(field === 'constructionYear' && value.toString().length > 4) return;
    setFormData(prev => ({
      ...prev,
      infrastructureEntity: {
        ...prev.infrastructureEntity,
        [field]: value
      }
    }));
  };

  const handleSave = () => {
    if (validateFields()) {
      const body = {
        ...formData.infrastructureEntity,
      }

      updateInfrastructureProject(tab as InfrastructureProjectType, body).then(() => {
        loadData();
        toast.success(t(`admin.success`, language));
      });
    }
  };

  const validateFields = () => {
    setErrors({});
    const newErrors: Record<string, boolean> = {};
    const { infrastructureEntity } = formData;

    keys.forEach(key => {
      if (isEmpty(infrastructureEntity[key])) {
        newErrors[key] = true;
      }
    })

    if (infrastructureEntity.requirements !== 'NOT_NEEDED') {
      ['requirementsRu', 'requirementsKz', 'lastMajorRenovation'].forEach(key => {
        if (isEmpty(infrastructureEntity[key as keyof IInfrastructureProject])) {
          newErrors[key] = true;
        }
      })
    }

    if (infrastructureEntity.documentationStatus === 'HAVE' && infrastructureEntity.requirements !== 'NOT_NEEDED') {
      ['workStart', 'workEnd', 'requiredFundSourceRu', 'requiredFundSourceKz', 'requiredFundAmount'].forEach(key => {
        if (isEmpty(infrastructureEntity[key as keyof IInfrastructureProject])) {
          newErrors[key] = true;
        }
      })

      infrastructureEntity.requiredFund && Object.entries(infrastructureEntity.requiredFund).forEach(([key, value]) => {
        if (isEmpty(value.value)) {
          newErrors[`requiredFund.${key}-value`] = true;
        }
      });
    }

    if (infrastructureEntity.sportSections && Object.entries(infrastructureEntity.sportSections).length === 0) {
      newErrors['sportSections'] = true;
      toast.error('Добавьте спортивные секции');
    }

    infrastructureEntity.sportSections && Object.entries(infrastructureEntity.sportSections).forEach(([key, value]) => {
      if (isEmpty(value) && key !== 'no') {
        newErrors[`sportSections.${key}`] = true;
      }
    });

    infrastructureEntity.additionalFields && Object.entries(infrastructureEntity.additionalFields).forEach(([key, value]) => {
      if (key.includes('text')) {
        newErrors[`additionalFields.${key}.textRu`] = isEmpty(value.textRu);
        newErrors[`additionalFields.${key}.textKz`] = isEmpty(value.textKz);
      } else {
        newErrors[`additionalFields.${key}.valueRu`] = isEmpty(value.valueRu);
        newErrors[`additionalFields.${key}.valueKz`] = isEmpty(value.valueKz);
      }
    });


    // if (!infrastructureEntity.files?.length) {
    //   toast.error('Загрузите фото');
    //   newErrors['files'] = true;
    // }

    setErrors(newErrors);

    return Object.values(newErrors).every(error => !error);
  };

  useEffect(() => {
    if (!data) return;
    setFormData(data);
  }, [data]);

  const renderFields = (lang: 'ru' | 'kz') => {
    const suffix = lang === 'ru' ? 'Ru' : 'Kz';
    const { infrastructureEntity } = formData;
    return (
      <div className={generalClasses[`fields-container`]}>
        <Field
          key={`name${suffix}`}
          label={t('projects.infrastructure-projects.name', lang)}
          value={infrastructureEntity?.[`name${suffix}`] || ''}
          onChange={(value) => {
            handleInputChange(`name${suffix}`, value);
          }}
          type="text"
          required
          error={errors[`name${suffix}`]}
        />

        <div className={`${generalClasses[`field-block`]} ${generalClasses[`field-block--gray`]}`}>
          {['constructionYear', 'factInfo', 'power'].map(field => {
            const val = infrastructureEntity?.[field as keyof typeof infrastructureEntity];
            const value = val === '' ? '' : val as string | number;

            return (
              <Field
                key={field}
                label={t(`projects.infrastructure-projects.education.${field}`, lang)}
                value={value ?? ''}
                onChange={(newValue) => {
                  const val = newValue === '' ? '' : +newValue;
                  handleInputChange(field, val);
                }}
                type="number"
                required
                error={errors[field]}
              />
            )
          })}
        </div>

        <div className={`${generalClasses[`field-block`]} ${generalClasses[`field-block--gray`]}`}>
          <div className={`${generalClasses['field-block__label']} ${generalClasses['required']}`}>{t(`${translationKey}.isSchool`, lang)}</div>
          <ReactSelect
            options={options(t, translationKey, lang)}
            value={findOptionByValue(infrastructureEntity?.isSchool, options(t, translationKey, lang))}
            onChange={(option) => handleInputChange('isSchool', option?.value || '')}
            placeholder=""
          />
        </div>

        <div className={`${generalClasses[`field-block`]} ${generalClasses[`field-block--gray`]}`}>
          <div className={`${generalClasses['field-block__label']} ${generalClasses['required']}`}>{t(`${translationKey}.factCondition`, lang)}</div>
          <ReactSelect
            options={conditionOptions(t, 'projects.infrastructure-projects', lang)}
            value={findOptionByValue(infrastructureEntity?.factCondition, conditionOptions(t, 'projects.infrastructure-projects', lang))}
            onChange={(option) => handleInputChange('factCondition', option?.value || '')}
            placeholder=""
          />
        </div>

        <div className={`${generalClasses[`field-block`]} ${generalClasses[`field-block--gray`]}`}>
          <div className={`${generalClasses['field-block__label']} ${generalClasses['required']}`}>{t(`${translationKey}.requirements`, lang)}</div>
          <ReactSelect
            options={requirementsOptions(t, 'projects.infrastructure-projects', lang)}
            value={findOptionByValue(infrastructureEntity?.requirements, requirementsOptions(t, 'projects.infrastructure-projects', lang))}
            onChange={(option) => handleInputChange('requirements', option?.value || '')}
            placeholder=""
          />
          {infrastructureEntity?.requirements && infrastructureEntity.requirements !== 'NOT_NEEDED' && (
            <>
              <Field
                label={t(`projects.infrastructure-projects.requirements-exactly`, lang)}
                value={infrastructureEntity?.[`requirements${suffix}`] || ''}
                onChange={(value) => handleInputChange(`requirements${suffix}`, value)}
                type="text"
                required
                error={errors[`requirements${suffix}`]}
              />

              <Field
                label={t(`projects.infrastructure-projects.last-major-renovation`, lang)}
                value={infrastructureEntity?.lastMajorRenovation?.split('T')[0] || ''}
                onChange={(value) => handleInputChange('lastMajorRenovation', value)}
                type="date"
                required
                error={errors['lastMajorRenovation']}
              />
            </>
          )}
        </div>


        {infrastructureEntity?.requirements && infrastructureEntity.requirements !== 'NOT_NEEDED' &&
          <Documentation
            data={formData}
            setData={setFormData}
            lang={lang}
            newFund={newFund}
            setNewFund={setNewFund}
            isAddingFund={isAddingFund}
            setIsAddingFund={setIsAddingFund}
            parentErrors={errors}
          />}

        <SportSections
          data={formData}
          setData={setFormData}
          lang={lang}
          newSection={newSection}
          setNewSection={setNewSection}
          isAddingSection={isAddingSection}
          setIsAddingSection={setIsAddingSection}
          parentErrors={errors}
        />

        <AdditionalInfo
          data={formData}
          setData={setFormData}
          lang={lang}
          newText={newText}
          setNewText={setNewText}
          newInfo={newInfo}
          setNewInfo={setNewInfo}
          isAddingText={isAddingText}
          setIsAddingText={setIsAddingText}
          isAddingInfo={isAddingInfo}
          setIsAddingInfo={setIsAddingInfo}
          parentErrors={errors}
        />
      </div>
    )
  }

  if (!data || !formData) return null;
  return (
    kato && <div className={classes[baseClass]}>
      <div className={generalClasses['grid']}>
        {renderFields(language === 'ru' ? 'ru' : 'kz')}
        {renderFields(language === 'ru' ? 'kz' : 'ru')}
      </div>

      <ImageGrid
        kato={+kato}
        imageData={formData.images}
        type={'infrastructure-projects'}
        objectId={formData.infrastructureEntity.id}
        setFormData={setFormData}
      />

      <FooterComponent
        onSave={handleSave}
        validateFields={validateFields}
      />
    </div>
  )
}

export default EducationTab